import type { ConceptDef } from '../types';

export const sequenceDailyRoutine: ConceptDef = {
  kind: 'sequenceTap',
  id: 'sequence-daily-routine',
  label: 'Sequence Daily Routine',
  category: 'Sequencing',
  description: 'Tap morning steps in order.',
  config: {
    promptMode: 'AUDIO',
    sequences: [
      { label: 'Morning routine.', items: ['😴 wake up', '🦷 brush teeth', '🥣 breakfast', '🎒 school'] },
      { label: 'Bedtime routine.', items: ['🛁 bath', '🪥 brush teeth', '📕 story', '😴 sleep'] },
    ],
  },
};
